module.exports = __webpack_public_path__ + "img/logo_text.1c94b33.svg";